import { TableRow, TableCell, Skeleton } from "@mui/material";
import { Fragment } from "react/jsx-runtime";

const LoadingRows = ({ count = 5 }: { count?: number }) => {
    return <Fragment>
        {Array.from(Array(count).keys()).map((index) => (
            <TableRow key={index} sx={{ height: '73px' }}>
                <TableCell>
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell>
                    <Skeleton variant="text" width={100} />
                </TableCell>
                <TableCell>
                    <Skeleton variant="rectangular" width={24} height={24} />
                </TableCell>
            </TableRow>))}
    </Fragment>

};

export default LoadingRows;